/**
 * Returns the picker list with already-selected poses removed when the company
 * has opted into deduping the picker (`hide_selected_poses_in_order_ui`). When
 * the flag is off, returns the input untouched.
 *
 * Safety guard: never filter the list down below the number of empty slots
 * remaining for the current product/slot, so a single-image gallery cannot be
 * emptied (regression we hit with Jelly Jar, ENG-2174).
 *
 * @param {Array} items full pose list before filtering
 * @param {Array<number|string>} selectedIds ids already selected for the current slot/product
 * @param {number} totalSlots how many poses the slot/product expects in total
 * @param {boolean} hideEnabled per-company opt-in flag
 * @returns {Array} possibly-filtered list
 */
export const filterSelectedPosesForPicker = (
  items,
  selectedIds,
  totalSlots,
  hideEnabled,
) => {
  if (!Array.isArray(items)) return items;
  if (!hideEnabled) return items;

  const cleanSelected = (selectedIds || []).filter(Boolean);
  if (cleanSelected.length === 0) return items;
  if (!(totalSlots > 1)) return items;

  const remainingSlots = totalSlots - cleanSelected.length;
  const filtered = items.filter((item) => !cleanSelected.includes(item.id));

  if (remainingSlots > 0 && filtered.length < remainingSlots) return items;

  return filtered;
};
